export default {
  retiredWarnings: {
    summary: 'Übergeordnete Anlage ist stillgelegt',
    details: 'Die übergeordnete Anlage ist stillgelegt. Diese Anlage wird beim Speichern automatisch ebenfalls stillgelegt.',
  },
};
